import React, { useEffect, useState } from 'react'
import { Table, Empty, Row, Col } from 'antd'
import _ from 'lodash'
import { useSnapshot } from 'valtio'
import useSWR from 'swr'
import { DateTime } from 'luxon'

import tableStore from '../../lib/store/login_activity_table'
import TableFilter from '../../components/TableFilter'
import { serialize } from '../../network/request'
import LoginActivityService from '../../network/services/login_activity'
import CSVButton from '../../components/CSVButton'

const LoginActivityTable = ({ total, overridePage }) => {
  const { state } = useSnapshot(tableStore)
  const [currentFilters, setCurrentFilters] = useState(null)

  const { data: response } = useSWR(
    serialize(LoginActivityService.getAll, {
      page: overridePage ?? state.currentPage,
      limit: state.pageSize,
      sort: state.sort ?? 'created_at:desc',
      refresh: state.refresh,
      ...state.filters
    })
  )
  const rows = LoginActivityService.toRow(response)

  const columns = [
    {
      title: 'Email',
      dataIndex: ['user', 'email'],
      key: ['user', 'email']
    },
    {
      title: 'Date',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text) => {
        return text ? DateTime.fromISO(text).toFormat('dd/MM/yyyy hh:mm:ss a') : ''
      }
    }
  ]

  const filterColumns = [{ key: 'email', name: 'Email' }]
  filterColumns.forEach((item) => {
    if (tableStore.state?.filters && Object.keys(tableStore.state.filters).includes(item.key)) {
      item.default_value = tableStore.state.filters[item.key]
      item.default = true
    }
  })

  useEffect(() => {
    if (currentFilters != null) {
      tableStore.state.filters = { ...currentFilters }
      tableStore.state.currentPage = 1
    }
  }, [currentFilters])

  return (
    <>
      <Row>
        <Col span={3}></Col>
        <Col span={21}>
          <Row align="end">
            <TableFilter
              dropdowns={[]}
              columns={filterColumns}
              hasDate={true}
              initial={state.filters}
              setCurrentFilters={setCurrentFilters}
            />

            <CSVButton
              path={serialize(LoginActivityService.getAll, {
                page: 1,
                limit: total,
                sort: state.sort ?? 'created_at:desc',
                ...state.filters
              })}
              filename="login_activities.csv"
              toRow={LoginActivityService.toRow}
              toCsv={(rows) => {
                return rows.map((row) => {
                  return {
                    email: row.user?.email,
                    date:
                      row.created_at &&
                      DateTime.fromISO(row.created_at).toFormat('dd/MM/yyyy hh:mm:ss a')
                  }
                })
              }}
            />
          </Row>
        </Col>
      </Row>

      {rows?.length > 0 ? (
        <Table
          columns={columns}
          dataSource={rows}
          onChange={(pagination, filters, sorter) => {
            // console.log(pagination, filters, sorter)

            tableStore.state.sort =
              sorter != null && !_.isEmpty(sorter?.columnKey) && !_.isEmpty(sorter?.order)
                ? `${sorter.columnKey ?? 'created_at'}:${
                    sorter.order === 'ascend' ? 'asc' : 'desc'
                  }`
                : null

            tableStore.state.currentPage = pagination.current
            // tableStore.state.pageSize = pagination.pageSize
          }}
          pagination={{
            total,
            pageSize: state.pageSize,
            current: state.currentPage
          }}
        />
      ) : (
        <Empty description={'No record found'} />
      )}
    </>
  )
}

export default LoginActivityTable
